module.exports = __webpack_public_path__ + "static/media/image_circle_search.b385500e.png";